import React, { useState, useEffect } from "react";
import { Col, Row, Divider, Button } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./ScaleReading.css";

export interface ScaleReadingProps {
  weight: string;
  scaleSerialPort: any;
  getPortAccess: () => void;
}

const ScaleReading = (props: ScaleReadingProps) => {
  return (
    <Col
      span={24}
      className="scale-reading-container"
      style={{ border: props.scaleSerialPort ? "4px solid green" : "4px solid red" }}
    >
      <Row justify="start">
        <Col span={8}>
          <h2>Raw Weight</h2>
        </Col>
        {props.scaleSerialPort ? (
          <>
            <Col span={10}>
              <Row justify="center" style={{ color: "green" }}>
                <h3 style={{ fontWeight: "bold" }}>
                  <CheckOutlined /> Port Connected
                </h3>
              </Row>
            </Col>
            <Col span={6}>
              <Row justify="end">
                <Button type="default" onClick={() => props.getPortAccess()}>
                  Reconnect
                </Button>
              </Row>
            </Col>
          </>
        ) : (
          <>
            <Col span={10}>
              <Row justify="center" style={{ color: "red" }}>
                <h3 style={{ fontWeight: "bold" }}>
                  <CloseOutlined /> Port Not Connected
                </h3>
              </Row>
            </Col>
            <Col span={6}>
              <Row justify="end">
                <Button type="default" onClick={() => props.getPortAccess()}>
                  Connect
                </Button>
              </Row>
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Divider style={{ margin: "5px 0" }} />
      </Row>
      <Row justify="center" align="middle">
        <span className="scale-reading-text">
          {props.weight} <span className="scale-reading-text-unit">kg</span>
        </span>
      </Row>
    </Col>
  );
};

export default ScaleReading;
